<template>
    <form class="form-horizontal" v-if="id_rastreador">
        <div class="form-group">
            <label for="ip_primario" class="col-sm-2 control-label">HODÔMETRO DO VEÍCULO:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="valor" class="form-control" id="ip_primario">
                <small>Favor enviar o hodômetro em <b>KILOMETRO</b></small>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR HODÔMETRO
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {Comandos} from "../../../class";
    import {Bus} from '../../../class/bus';
    import HabilitarMtk from '../../buttons/HabilitarMtk.vue';
    import HabilitarHodmetro from '../../buttons/HabilitarHodometro.vue';
    import HabilitarHodmetroMetragem from '../../buttons/HabilitarHodometroMetragem.vue';
    export default {
        components: {HabilitarHodmetroMetragem, HabilitarHodmetro, HabilitarMtk},
        props: {
            id_rastreador: {
                default: null
            }
        },
        data () {
            return {
                valor: 0
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Comandos.ajustarHodometro(this.id_rastreador, this.valor);
                        Bus.$emit('comandos');
                        toastr.success("Hodômetro enviado!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Hodômetro não enviado!");
                    }
                });
            }
        }
    }
</script>

<style scoped>
tr.spaceUnder>td {
    padding-bottom: 1em;
}
</style>
